import { machineTypeSchema } from "@packsize/schemas/machines";

export const CVP_RANGE_MACHINES_QUERY_KEY = ["machines", { machineType: machineTypeSchema.enum.CVPRange }] as const;
